import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Field } from '@models/ui'
import { parseConfigureJson } from '@app/feature/add-field/add-field-content/add-field-content-common'
import { TbToggleComponent } from '@components-library/tb-toggle/tb-toggle.component'
import { TranslocoDirective } from '@jsverse/transloco'
import { FieldTypes } from '@core/models'
import { FieldSettingsComponent } from '@app/feature/add-field/add-field-content/add-field-content.component'

export interface PeopleCellSettings {
    isOneAssignable: boolean
}

@Component({
    selector: 'app-people-cell-settings',
    imports: [TbToggleComponent, TranslocoDirective],
    templateUrl: './people-cell-settings.component.html',
})
export class PeopleCellSettingsComponent implements OnInit, FieldSettingsComponent {
    @Input() field!: Field

    @Output() configurationChanged: EventEmitter<PeopleCellSettings> =
        new EventEmitter<PeopleCellSettings>()

    isOneUser = false
    isAssignee = false

    ngOnInit() {
        const parsedJson = parseConfigureJson<PeopleCellSettings>(this.field.configure_json)
        if (parsedJson) {
            this.isOneUser = parsedJson.isOneAssignable
        }

        if (this.field.field_type_code === FieldTypes.ASSIGNEE) this.isAssignee = true
    }

    onChange(isOneUser: boolean) {
        this.isOneUser = isOneUser
        this.configurationChanged.emit({ isOneAssignable: isOneUser })
    }
}
